import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import "../item.css";
import { genericEntityService } from '../../../../services/genericEntityService';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { useErrorHandler } from '../../shared/errorHandler';

export const AttachmentFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;
    const { handleHttpError } = useErrorHandler();

    const [fileSizeExceeded, setFileSizeExceeded] = useState(null);
    const file = itemForm.form[field.Code];

    const handleUpload = ({ files }) => {
        const file = files[0];

        if (field.MaxFileSizeInBytes !== null && file.size > field.MaxFileSizeInBytes) {
            setFileSizeExceeded(true);
            changeValueCallback({
                ...itemForm,
                errors: {
                    ...itemForm.errors,
                    [field.Code]: t('NgeInvalidRange')
                }
            });
            return;
        }

        setFileSizeExceeded(false);

        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: file,
            },
            errors: {
                ...itemForm.errors,
                [field.Code]: null
            }
        });
    };

    const handleClear = () => {
        setFileSizeExceeded(false);

        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: null,
            },
            errors: {
                ...itemForm.errors,
                [field.Code]: null
            }
        });
    };

    const onTemplateRemove = (file, onRemove) => {
        onRemove();

        setFileSizeExceeded(false);

        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: null
            },
            errors: {
                ...itemForm.errors,
                [field.Code]: null
            }
        });
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>

                <Tag value={props.formatSize} style={{background: '#3798c7'}} className="px-3 py-2" />

                <Button
                    type="button"
                    icon="pi pi-times"
                    className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                    onClick={() => onTemplateRemove(file, props.onRemove)}
                />
            </div>
        );
    };

    const handleFileDownload = (filename, attachmentId) => {
        genericEntityService.getFile(attachmentId)
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(link);
            })
            .catch(function (error) { handleHttpError(error); });
    };

    const existingAttachment = file && !(file instanceof File)
        ? { fileName: file.FileName || file.fileName, attachmentId: file.AttachmentId || file.attachmentId }
        : null;

    const fieldLabel = field.Captions[currentLanguage]?.length > 0
        ? field.Captions[currentLanguage]
        : field.Code;

    return (
        <div className="attachment">

            {!isDisabled && (
                <>
                    {existingAttachment ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span>{fieldLabel}:</span>
                            <a
                                className="link"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleFileDownload(existingAttachment.fileName, existingAttachment.attachmentId)}
                            >
                                {existingAttachment.fileName}
                            </a>
                            <Button
                                type="button"
                                icon="pi pi-times"
                                className="p-button-outlined p-button-rounded p-button-danger p-button-sm"
                                onClick={handleClear}
                            />
                        </div>
                    ) : (
                        <FileUpload
                            name="file"
                            customUpload
                            uploadHandler={handleUpload}
                            onClear={handleClear}
                            itemTemplate={itemTemplate}
                            auto
                            mode="advanced"
                            maxFileSize={field.MaxFileSizeInBytes || undefined}
                            chooseOptions={{
                                style: {
                                    background: "#3798c7",
                                    border: "none"
                                },
                                label: field.Captions[currentLanguage]?.length >= 0
                                    ? `${field.Captions[currentLanguage]} ${field.IsMandatory ? '*' : ''}`
                                    : `${field.Code} ${field.IsMandatory ? '*' : ''}`,
                            }}
                        />
                    )}
                </>
            )}

            {isDisabled && (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <span>
                        {fieldLabel}:
                        <a
                            className="link"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                handleFileDownload(
                                    itemForm.form[field.Code]?.FileName || itemForm.form[field.Code]?.fileName,
                                    itemForm.form[field.Code]?.AttachmentId || itemForm.form[field.Code]?.attachmentId
                                )
                            }
                        >
                            {itemForm.form[field.Code]?.FileName || itemForm.form[field.Code]?.fileName}
                        </a>
                    </span>
                </div>
            )}

        </div>
    );
};